import React from "react";
import { useNavigate } from "react-router-dom";
import "./PartnerDashboard.css";

const PartnerDashboard = () => {
  const navigate = useNavigate();

  const menuItems = [
    { label: "Partner Meeting Display", path: "partner-meeting-display" },
    { label: "Secondary Balance Enquiry", path: "secondary-balance-enquiry" },
    { label: "Partner Meeting", path: "partner-meeting" },
    { label: "Finance Add Credit", path: "finance-add-credit" },
    { label: "Excel Account", path: "excel-account" },
    { label: "Partner Account", path: "partner-account" },
    { label: "Daily Cashbook", path: "daily-cashbook" },
    { label: "Finance Meeting", path: "finance-meeting" },
  ];

  return (
    <div className="partner-dashboard">
      <div className="dashboard-header">
        <h1>🤝 Partner Dashboard</h1>
        <p>Welcome to your financial control panel</p>
      </div>

      <div className="dashboard-grid">
        {menuItems.map((item, index) => (
          <div
            key={index}
            className="dashboard-card"
            onClick={() => navigate(`/partner-dashboard/${item.path}`)}
          >
            <div className="card-content">
              <h3>{item.label}</h3>
              <span className="arrow">→</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PartnerDashboard;
